export enum QuestionnaireRequestStatus {
  APPROVED = "APPROVED",
  IN_PROGRESS = "IN_PROGRESS",
  REJECTED = "REJECTED",
  SENT = "SENT",
  SUBMITTED = "SUBMITTED"
}
